import {
  Card as MuiCard,
  CardContent as MuiCardContent,
  Typography as MuiTypography,
  Button as MuiButton,
  Box as MuiBox,
} from "@mui/material";
import {
  Verified as MuiVerifiedIcon,
  Visibility as MuiVisibilityIcon,
} from "@mui/icons-material";
import PropTypes from "prop-types";
import { t } from "i18next";

const ContentRevisionCard = ({
  title,
  createdDate,
  onClick,
  onClickRestore,
  isPublished = false,
  isCurrentDraft = false,
  variant = "draft",
}) => {
  return (
    <MuiCard
      onClick={onClick}
      sx={{
        mb: 2,
        backgroundColor: `${isCurrentDraft ? "#dddddd" : "#ffffff"}`,
      }}
    >
      <MuiCardContent sx={{ padding: "8px 12px" }}>
        <MuiBox sx={{ float: "right" }}>
          {isPublished && (
            <MuiVerifiedIcon sx={{ float: "right", height: "0.7em" }} />
          )}
          {isCurrentDraft && (
            <MuiVisibilityIcon sx={{ float: "right", height: "0.7em" }} />
          )}
          {onClickRestore && (
            <MuiButton sx={{ float: "right" }} onClick={onClickRestore}>
              {t("StudyWebisteContentForm.restoreButtonLabel")}
            </MuiButton>
          )}
        </MuiBox>
        <MuiTypography variant="body1">{title}</MuiTypography>
        <MuiTypography variant="body2" color="textSecondary">
          {createdDate}
        </MuiTypography>
      </MuiCardContent>
    </MuiCard>
  );
};

ContentRevisionCard.propTypes = {
  title: PropTypes.string.isRequired,
  createdDate: PropTypes.string.isRequired,
  onClickRestore: PropTypes.func,
  isPublished: PropTypes.bool,
  isCurrentDraft: PropTypes.bool,
  variant: PropTypes.string,
  onClick: PropTypes.func,
};

export default ContentRevisionCard;
